@use 'styles/mixins/fonts' as *;

.labelPrimaryText {
    @include normalSemiboldFont;
}
